// extracted by mini-css-extract-plugin
export default {"root":"Dropdown_root__UIBWv","header":"Dropdown_header__rbG68","container":"Dropdown_container__Xl5JY","arrow":"Dropdown_arrow__420gD"};